import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import { useAuth } from '@/common/contexts/AuthContext';
import withBuild from '@/common/hoc/build/withBuild';
import PrivateRouteRedirect from '@/common/router/PrivateRouteRedirect';

const PrivateRoute = ({ children, layout, defaultLayout, ...rest }) => {
  const { isLoggedIn } = useAuth();

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={({ location }) => (
        <>
          {isLoggedIn ? (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <defaultLayout.Component {...defaultLayout.props}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <layout.Component {...layout.props}>{children}</layout.Component>
            </defaultLayout.Component>
          ) : (
            <PrivateRouteRedirect location={location} />
          )}
        </>
      )}
    />
  );
};

PrivateRoute.defaultProps = {
  layout: {
    Component: Fragment,
    props: {},
  },
  defaultLayout: {
    Component: Fragment,
    props: {},
  },
};

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  layout: PropTypes.shape({
    Component: PropTypes.elementType,
    // eslint-disable-next-line react/forbid-prop-types
    props: PropTypes.object,
  }),
  defaultLayout: PropTypes.shape({
    Component: PropTypes.elementType,
    // eslint-disable-next-line react/forbid-prop-types
    props: PropTypes.object,
  }),
};

export default withBuild(PrivateRoute);
